import Vue from 'vue'
export default Vue.observable({ editMessage: null })


// WEBPACK FOOTER //
// ./src/components/vue-beautiful-chat/src/store/index.js